import {
  Package,
  Boxes,
  Box,
  Container,
  Truck,
  Pill,
  Apple,
  Wheat,
  Beef,
  Fish,
  Milk,
  Coffee,
  Wine,
  Shirt,
  Cpu,
  Smartphone,
  Laptop,
  Tv,
  Refrigerator,
  Armchair,
  Sofa,
  Car,
  Wrench,
  Hammer,
  Factory,
  FlaskConical,
  Fuel,
  Flame,
  Leaf,
  TreePine,
  Flower2,
  PawPrint,
  Gem,
  Paintbrush,
  BookOpen,
  Cigarette,
  Droplet,
  Snowflake,
  Recycle,
  type LucideIcon,
} from 'lucide-react'

/**
 * Curated icon set for the goods catalog — the single source shared by
 * tenant-web (search results) and rr-admin (icon picker). Goods store the
 * string key; both apps resolve it through this map.
 */
export const CARGO_ICON_MAP: Record<string, LucideIcon> = {
  Package,
  Boxes,
  Box,
  Container,
  Truck,
  Pill,
  Apple,
  Wheat,
  Beef,
  Fish,
  Milk,
  Coffee,
  Wine,
  Shirt,
  Cpu,
  Smartphone,
  Laptop,
  Tv,
  Refrigerator,
  Armchair,
  Sofa,
  Car,
  Wrench,
  Hammer,
  Factory,
  FlaskConical,
  Fuel,
  Flame,
  Leaf,
  TreePine,
  Flower2,
  PawPrint,
  Gem,
  Paintbrush,
  BookOpen,
  Cigarette,
  Droplet,
  Snowflake,
  Recycle,
}

/** Ordered list of icon names for pickers. */
export const CARGO_ICON_NAMES = Object.keys(CARGO_ICON_MAP)

/** Fallback when a good has no icon or an unknown name. */
export const DEFAULT_CARGO_ICON: LucideIcon = Package

/** Resolve a stored icon name to a component, falling back to the default. */
export function resolveCargoIcon(name?: string | null): LucideIcon {
  if (name && CARGO_ICON_MAP[name]) return CARGO_ICON_MAP[name]
  return DEFAULT_CARGO_ICON
}
